module.exports = __webpack_public_path__ + "static/media/Montserrat-Black.55e37a35.ttf";